import React from "react";

import MainContainer from "../containers/MainContainer";
import WebHiClassInfoContainer from "../containers/etc/WebHiClassInfoContainer";
import WebContentTemplate from "../components/template/WebContentTemplate";

const WebHiClassInfoPage = ({ browserType, currentPageType, cookies, routeProps }) => {
    return (
        <MainContainer 
            browserType={browserType} 
            cookies={cookies} 
            currentPageType={currentPageType} 
            routeProps={routeProps}
        >
            <WebContentTemplate>
                <WebHiClassInfoContainer routeProps={routeProps} />
            </WebContentTemplate>
        </MainContainer>
    );
};

export default WebHiClassInfoPage;